import React from "react";
import ReactDOM from "react-dom";
import { Paper, TextField, Typography } from '@mui/material';
import MonacoEditor from '@monaco-editor/react'

export default function Root(props) {

  return <div style={{
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '8px'
  }}>
     <MonacoEditor 
        onChange={(e) => props.onChange?.(e)}
        theme={props.theme || ""}
        value={props.value || ""} 
        defaultValue={props.defaultValue} />
    </div>;
}
